import { CameraIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel, useKestrelViewerContext } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC } from 'react'

export const ToggleCameraPosesButton: FC = () => {
  const { kestrelModel } = useKestrel()
  const { sendCommand, cameraPosesVisible, setCameraPosesVisible } =
    useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()

  const handleClick = () => {
    const newValue = !cameraPosesVisible
    setCameraPosesVisible(newValue)
    sendCommand({
      command: KestrelCommands.SET_CAMERA_POSES_VISIBILITY,
      cameraPosesVisible: newValue,
    })
    trackButtonClicked({
      button_name: 'kestrel_toggle_camera_poses',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
    })
  }

  if (!kestrelModel?.id || !kestrelModel?.data.photosEnabled) {
    return null
  }

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Toggle Camera Poses'}>
      <ViewToggle onClick={handleClick}>
        <CameraIcon
          style={{ color: cameraPosesVisible ? 'white' : 'gray' }}
          width={22}
          height={22}
        />
      </ViewToggle>
    </TooltipWrapper>
  )
}
